import { BackrsIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { SearchedUser } from '@backrs_ui/grow-ui/src/models/models';

import { Box, SxProps, Theme, Typography } from '@mui/material';

const SUPERCOACH_STRINGS = appStrings.modules.supercoach;

type SelectedUserProps = Readonly<{
  user: SearchedUser;
}>;

export const SelectedUser = ({ user }: SelectedUserProps) => {
  return (
    <Box sx={containerStyle}>
      <Box sx={messageContainerStyle}>
        <Typography sx={selectedTextStyle}>{SUPERCOACH_STRINGS.selected}</Typography>
        <Box sx={selectedUserContainerStyle}>
          {user?.profile_image ? (
            <img src={user?.profile_image} alt={user.name} style={profilePictureStyle} />
          ) : (
            <BackrsIcon name="MyAccountLogo" alt={user.name} style={profilePictureStyle} />
          )}
          <Typography variant="text-sm-bold">{user?.name}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
const containerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  marginTop: backrs.spacing['spacing-lg'],
});

const messageContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: backrs.spacing['spacing-lg'],
});

const selectedUserContainerStyle: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: backrs.spacing['spacing-md'],
});

const profilePictureStyle: React.CSSProperties = {
  width: '18px',
  height: '18px',
  borderRadius: '50%',
} as const;

const selectedTextStyle: React.CSSProperties = {
  fontSize: '11pt',
} as const;
